export default __webpack_public_path__ + "static/m-customer7-644249df0c352eba9fa4e3471a2c42d5.png";